import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'how_does_the_fac_prov_comm_and_training_to_individuals_responsi'

export const dataPointDefinition = {
  retracedId: 'how_does_the_fac_prov_comm_and_training_to_individuals_responsi',
  name: 'How does the facility provide communication and training to individuals responsible for implementation?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'VERBAL_COMMUNICATION',
      text: 'Verbal communication',
      externalIds: [
        {
          id: 'ms-5--4-1x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WRITTEN_COMMUNICATION_I_E_COPY_OF_STANDARD_OPERATING_PROCEDURES',
      text: 'Written communication (i.e. copy of Standard Operating Procedures or "SOPs")',
      externalIds: [
        {
          id: 'ms-5--4-2x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_NEW_WORKERS_RECEIVE_ONBOARDING_TRAININGS_IN_PERSON_I_E',
      text: 'Training - new workers receive onboarding trainings in-person (i.e. classroom trainings)',
      externalIds: [
        {
          id: 'ms-5--4-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'TRAINING_EXISTING_WORKERS_RECEIVE_ON_GOING_TRAININGS_IN_PERSON_',
      text: 'Training - existing workers receive on-going trainings in-person (i.e. classroom trainings)',
      externalIds: [
        {
          id: 'ms-5--4-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_DOES_NOT_PROVIDE_COMMUNICATION_AND_TRAINING_TO_IND',
      text: 'The facility does not provide communication and training to individuals responsible for implementation',
      externalIds: [
        {
          id: 'ms-5--4-5x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-5--4-6x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-5--4-6f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'VERBAL_COMMUNICATION',
                'WRITTEN_COMMUNICATION_I_E_COPY_OF_STANDARD_OPERATING_PROCEDURES',
                'TRAINING_NEW_WORKERS_RECEIVE_ONBOARDING_TRAININGS_IN_PERSON_I_E',
                'TRAINING_EXISTING_WORKERS_RECEIVE_ON_GOING_TRAININGS_IN_PERSON_',
                'THE_FACILITY_DOES_NOT_PROVIDE_COMMUNICATION_AND_TRAINING_TO_IND',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-do-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 21770,
  sectionId: '2.2.6.12',
  impactArea: 'Management Systems',
  impactAreaId: 'MANAGEMENT_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
